import React from "react";

import { Button } from "components/Graphs/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/Graphs/Dialogue";

interface TransferOwnershipDialogProps {
  memberName: string;
  memberEmail: string;
  open: boolean;
  isSubmitting: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}

export function TransferOwnershipDialog({
  memberName,
  memberEmail,
  open,
  isSubmitting,
  onConfirm,
  onOpenChange,
}: TransferOwnershipDialogProps) {
  const memberLabel = memberName
    ? `${memberName} (${memberEmail})`
    : memberEmail;

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!isSubmitting) {
          onOpenChange(nextOpen);
        }
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Transfer organization ownership?</DialogTitle>
          <DialogDescription>
            {memberLabel} will become the owner of this organization, and you
            will become an admin.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="secondary"
            disabled={isSubmitting}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            isLoading={isSubmitting}
            loadingText="Transferring"
            onClick={onConfirm}
          >
            Transfer ownership
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
